import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["element"]

  closeModal() {
    $("#modal-holder-2").find(".modal, .fade, .in").remove()
  }
}
